import styled from 'styled-components';
import { colourPalette } from 'styles/styles';
export const HeyYabbleCountStepTableHeaderStyle = {
  Container: styled.div`
    background-color: ${colourPalette.neutral100};
    height: 40px;
    display: flex;
    font-weight: 600;
    color: ${colourPalette.neutral500};
  `,
  CheckContainer: styled.div`
    width: 40px;
    border-right: 1px solid ${colourPalette.neutral300};
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  ItemContainer: styled.div`
    flex: 1;
    padding: 0 12px;
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 24px;
  `,
  WidthItem: styled.div`
    width: 96px;
    border-left: 1px solid ${colourPalette.neutral300};
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 12px;
    font-size: 12px;
    line-height: 24px;
  `,
  DropdownsItem: styled.div`
    width: 400px;
    border-left: 1px solid ${colourPalette.neutral300};
    padding: 0 12px;
    font-size: 12px;
    line-height: 24px;
    display: flex;
    align-items: center;
  `,
};
